// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UsbOutlinedSvg from "@ant-design/icons-svg/es/asn/UsbOutlined";
import AntdIcon from '../components/AntdIcon';

var UsbOutlined = function UsbOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UsbOutlinedSvg
  }));
};

UsbOutlined.displayName = 'UsbOutlined';
export default React.forwardRef(UsbOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/UsbOutlined.js
// module id = 2003
// module chunks = 0